import { styled } from '@linaria/react'

export const HeroBlockWrapper = styled.section`
  position: relative;
  padding: 16rem 0 4rem;
  background-color: ${props => props.background};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;

  h1 {
    padding-bottom: 1rem;
    letter-spacing: -0.1rem;
  }

  p {
    font-size: var(--font-size-p2);
  }

  .hero-stage {
    &__content {
      position: relative;
      padding-inline: var(--size-md);
      margin-inline: auto;
      width: 100%;
      max-width: var(--content-size);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-end;
      color: ${props => (props.white ? 'var(--white)' : 'inherit')};
      z-index: 1;

      &--text {
        flex: 0 1 100%;

        &.half {
          flex: 0 1 60%;
          margin-right: 6.5%;
        }
      }

      &--image {
        position: relative;
        flex: 1;

        img {
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  }

  &.background-image {
    min-height: 60rem;

    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 50%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(
        to bottom,
        rgba(64, 56, 41, 1) 0%,
        rgba(64, 56, 41, 0) 100%
      );
      opacity: 0.5;
    }
  }

  &.background-video {
    padding: 0;

    .player-wrapper {
      height: auto;

      .react-player {
        position: relative;
        padding-bottom: 45%;
        overflow: hidden;

        @media (max-width: 500px) {
          padding-bottom: 55%;
        }
      }

      &.is-small {
        .react-player {
          padding-bottom: 26%;
        }
      }

      iframe,
      video {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-width: 100%;
        min-height: 100%;
        pointer-events: none;
        object-fit: cover;
        object-position: 50% 50%;
      }

      iframe {
        min-height: 130%;
      }
    }
  }

  &.background-text {
    overflow: hidden;

    .player-wrapper {
      iframe,
      video {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-width: 100%;
        min-height: 100%;
        pointer-events: none;
        object-fit: cover;
        object-position: 50% 50%;
      }
    }

    h1.wp-block-heading {
      font-size: 7.25rem;
      line-height: 8rem;
      font-weight: var(--font-weight-bolder);
      background: ${props =>
        props.textImage && !props.isEditor
          ? 'url(' + props.textImage + ')  0 0 / cover no-repeat'
          : 'none'};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  @media (max-width: 768px) {
    padding: 10rem 0 2.5rem;

    h1 {
      padding-bottom: 0;
      letter-spacing: -0.05rem;
    }

    .hero-stage {
      &__content {
        &--text {
          order: 1;

          &.half {
            flex: 0 1 100%;
            margin-right: 0;
          }
        }

        &--image {
          display: none;
          margin-bottom: 2rem;
          text-align: center;

          img {
            position: relative;
            max-width: 18rem;
            height: auto;
          }
        }
      }
    }

    &.background-image {
      min-height: 21.25rem;
    }

    &.background-text {
      h1.wp-block-heading {
        font-size: 3.125rem;
        line-height: 3.2rem;
        margin-bottom: 0.5rem;
      }
    }
  }
`
